const baseURL = process.env.REACT_APP_API_BASE_URL;
// const baseURL = "http://localhost:3001";
console.log("baseURL  : ", baseURL);
export default baseURL;
